module.exports = __webpack_public_path__ + "static/img/preview-01.eee31bdf.webp";